export const DEFAULT_MIN_PARTY_SIZE = 1
export const DEFAULT_MAX_PARTY_SIZE = 8
